import {Component, OnInit} from '@angular/core';
import {PageChangeEvent} from "@progress/kendo-angular-pager";
import {AvaliacaoService} from "../../services/avaliacao.service";

@Component({
  selector: 'app-tela-lista-avaliacoes',
  templateUrl: './tela-lista-avaliacoes.component.html',
  styleUrls: ['./tela-lista-avaliacoes.component.scss']
})
export class TelaListaAvaliacoesComponent implements OnInit {
  avaliacoes: Array<any> = [];
  total = 0;
  loading = false;
  erro = '';
  inicio = 0;
  tamanhoPagina = 10;
  estrelas = [1, 2, 3, 4, 5];
  modoGrupoLojas = false;
  notaMediaUltimos30Dias: any = {
    qtdeAvaliacoes: 0,
    media: 0,
  };
  notaGeral: any = {
    qtdeAvaliacoes: 0,
    media: 0,
  };

  constructor(private avaliacaoService: AvaliacaoService) { }

  ngOnInit(): void {
    this.carregue(0);
  }

  mudouPagina($event: PageChangeEvent) {
    this.carregue($event.skip);
  }

  carregue(inicio: number) {
    this.inicio = inicio;
    this.loading = true;
    this.erro = '';

    this.avaliacaoService.liste(this.inicio, this.tamanhoPagina).then( (respAvaliacoes) => {
      this.loading = false;
      if (!respAvaliacoes) {
        return
      }

      this.notaGeral = respAvaliacoes.notaMediaGeral;
      this.notaMediaUltimos30Dias = respAvaliacoes.notaMediaUltimos30Dias;
      this.avaliacoes = respAvaliacoes.avaliacoes || [];
      this.total = respAvaliacoes.total || 0;
    }).catch( (erro) => {
      this.loading = false;
      this.erro = typeof erro === 'string' ? erro : 'Não foi possível carregar as avaliações.';
    });
  }

  percentualEstrelas(media: number) {
    return Math.max(0, Math.min(100, (Number(media) || 0) / 5 * 100));
  }

  iniciais(nome: string) {
    const partes = (nome || '').trim().split(/\s+/).filter((parte) => parte);

    if (!partes.length) return '?';
    if (partes.length === 1) return partes[0].charAt(0).toUpperCase();

    return (partes[0].charAt(0) + partes[partes.length - 1].charAt(0)).toUpperCase();
  }

  tempoParaAvaliar(avaliacao: any) {
    return (avaliacao.tempoAvaliarDescricao || '').replace('há ', '').replace('em ', '');
  }

  get ultimoItemDaPagina() {
    return Math.min(this.inicio + this.tamanhoPagina, this.total);
  }
}
